/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');
var bodybuilder = require('bodybuilder');
var GridView = require('psa-marionette/views/GridView');
var PageableCollection = require('psa-backbone/models/PageableCollection');
var Constants = require('../../common/util/constants');

var StringCell = require('common/backgrid/StringCell');
var COCSelectRowCell = require('../../common/backgrid/COCSelectRowCell');

var ElasticSearchSummaryView = require('common/views/ElasticSearchSummaryView');

var SearchCOCContacts = require('../../internal-dashboard/services/SearchCOCContacts');

var tmplSearchForContactModalView = require('../templates/COCSearchForContactModalView.hbs');
require('../styles/COCSearchForContactModalView.css');

module.exports = Marionette.LayoutView.extend({
  template: tmplSearchForContactModalView,

  className: 'coc-search-for-contact-modal-view',

  ui: {
    searchSummary: '.search-summary',
    searchResultsContainer: '.search-results-container',
    search: '.search',
    submit: '.submit',
    noContactSelected: '#noContactSelected',
    formInputs: ':input'
  },

  regions: {
    searchResultsContainer: '@ui.searchResultsContainer',
    searchSummary: '@ui.searchSummary'
  },

  events: {
    'click @ui.search': 'onClickSearch',
    'click @ui.submit': 'onClickSubmit',
    'keydown @ui.formInputs': 'onKeydownOfInputs'
  },

  onBeforeShow: function() {
    this.searchSummaryView = new ElasticSearchSummaryView({
      model: new Backbone.Model({
        searchLimit: this.model.get('searchLimit')
      })
    });
    this.showChildView('searchSummary', this.searchSummaryView);

    this.searchResults = new GridView({
      columns: [
        {
          name: 'isChecked',
          label: '',
          cell: COCSelectRowCell.SelectRowCell,
          headerCell: 'custom',
          width: 5,
          editable: true,
          sortable: false,
          singleSelect: true
        },
        {
          name: 'contactName',
          label: 'Contact Name',
          cell: StringCell,
          headerCell: 'custom',
          width: 20,
          editable: false
        },
        {
          name: 'contactPhone',
          label: 'Contact Phone',
          cell: StringCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'contactEmail',
          label: 'Contact Email',
          cell: StringCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'contactEntities',
          label: 'Entity Names',
          cell: StringCell,
          headerCell: 'custom',
          width: 20,
          editable: false
        }
      ],
      collection: new PageableCollection([], { pageSize: 3 }),
      emptyText: 'No Contacts Found'
    });
    this.showChildView('searchResultsContainer', this.searchResults);

    this.$('.backgrid.table').addClass('table-bordered');
  },

  onKeydownOfInputs: function(e) {
    // Searches on press of enter
    if (e.keyCode === 13) {
      this.onClickSearch(e);
    }
  },

  onClickSearch: function() {
    var self = this;
    var data = Syphon.serialize(this, {
      inputReaders: Syphon.SearchInputReaderSet
    });

    // If no inputs were given, do not perform a search.
    if (!data.contactName && !data.contactPhone && !data.contactEmail && !data.entityName) {
      return;
    }
    this.searchSummaryView.reset();

    var l = Ladda.create(this.ui.search[0]);
    l.start();
    var body = bodybuilder();

    if (data.contactName) {
      body.query('bool', function(b) {
        b.orQuery('match', 'contactName', {
          query: data.contactName,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'contactName', data.contactName.toLowerCase() + '*');
        b.orQuery('match', 'contactName.phonetic', data.contactName);
        return b;
      });
    }

    if (data.contactPhone) {
      body.query('wildcard', 'contactPhone', data.contactPhone + '*');
    }

    if (data.contactEmail) {
      body.query('bool', function(b) {
        b.orQuery('match', 'contactEmail', {
          query: data.contactEmail,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'contactEmail', data.contactEmail.toLowerCase() + '*');
        b.orQuery('match', 'contactEmail.phonetic', data.contactEmail);
        return b;
      });
    }

    if (data.entityName) {
      body.query('bool', function(b) {
        b.orQuery('match', 'contactEntities', {
          query: data.entityName,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'contactEntities', data.entityName.toLowerCase() + '*');
        b.orQuery('match', 'contactEntities.phonetic', data.entityName);
        return b;
      });
    }

    body.size(this.model.get('searchLimit'));
    var bodyObj = body.build();

    SearchCOCContacts(bodyObj)
      .done(function(data) {
        l.stop();
        self.searchResults.collection.fullCollection.reset(data.hits);
        self.searchSummaryView.display(data);
      })
      .fail(function() {
        l.stop();
      });
  },

  onClickSubmit: function() {
    this.ui.noContactSelected.hide();

    var selectedContact = this.searchResults.collection.fullCollection.findWhere({
      isChecked: true
    });

    if (this.model.get('searchEntityType') === Constants.ORGANIZATION && !selectedContact) {
      this.ui.noContactSelected.show();
      return;
    } else {
      this.ui.noContactSelected.hide();

      this.triggerMethod('modal:close', selectedContact);
    }
  }
});
